/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { ScoreCardRuleCreateRequest } from "./ScoreCardRuleCreateRequest"
import type { TableFeatureCriterionRequest } from "./TableFeatureCriterionRequest"

export type ScoreCardCreateUpdateRequest = {
  name: string
  rules?: Array<ScoreCardRuleCreateRequest>
  /**
   * * `LIST` - LIST
   * * `TABLE` - TABLE
   */
  format?: ScoreCardCreateUpdateRequest.format
  /**
   * list of floats representing the return values
   */
  results?: Array<number> | null
  criteria?: Array<Array<TableFeatureCriterionRequest> | null> | null
  features?: Array<string> | null
  /**
   * the default score for scorecard if not sent defaults to 0
   */
  default_score?: string
}
export namespace ScoreCardCreateUpdateRequest {
  /**
   * * `LIST` - LIST
   * * `TABLE` - TABLE
   */
  export enum format {
    LIST = "LIST",
    TABLE = "TABLE",
  }
}
